<template>
  <div>
    <!-- <div class="totalPie">
      <div class="tit">
        <p>应急预案</p>
      </div>
      <ul class="yjlist listb">
        <li>
          <div>
            <p class="titnames">预案名</p>
          </div>
          <div>
            <p class="titnames1">预案等级</p>
          </div>
        </li>
      </ul>
      <ul class="yjlist">
        <li v-for="(item,i) in yjlist" :key="i" :class="yjlist.length-1==i?'ddd':''" @click="dialog()">
          <div>
            <p class="titnames">{{item.ydbFhyaMc}}</p>
          </div>
          <div>
            <p class="titnames1" :style="item.ydbSjfj+1 == 1 ? 'color:red' :
            (item.ydbSjfj+1 == 2 ? 'color:orange' : (item.ydbSjfj+1 == 3 ? 'color:yellow' : 'color:green'))">{{item.ydbSjfj+1}}级</p>
          </div>
        </li>
      </ul>
    </div> -->
    <div class="zrrlist">
      <!-- 耿彪修改 -->
      <div class="tit">
        <p>安全监测预警</p>
      </div>
      <ul class="listwarning listb">
        <li>
          <div>
            <p class="titnames1">淤地坝名称</p>
          </div>
          <div>
            <p class="titnames1">坝体位移监测</p>
          </div>
          <div>
            <p class="titnames1">泄水部位变形监测</p>
          </div>
          <!-- <div>
            <p class="titnames1">溃坝指数</p>
          </div> -->
        </li>
      </ul>
      <ul class="listwarning">
        <li v-for="(item,i) in warninglist" :key="i">
          <div>
            <p class="titnames">{{item.ydbName}}</p>
          </div>
          <div>
            <p class="titnames" v-if="item.lswyjWxzs!=null" :style="item.lswyjWxzs == 0 ? 'color:lime' : 'color:#ff6464'">{{item.lswyjWxzs == 0 ? "正常" : "报警"}}</p>
            <p class="titnames" v-if="item.lswyjWxzs==null" :style="item.lswyjWxzs == null ? 'color:lime' : 'color:#ff6464'">正常</p>
          </div>
          <div>
            <p class="titnames1" v-if="item.ztcgqWxzs!=null" :style="item.ztcgqWxzs == 1 ? 'color:lime' : 'color:#ff6464'">{{item.ztcgqWxzs == 1 ? "正常" : "报警"}}</p>
            <p class="titnames1" v-if="item.ztcgqWxzs==null" :style="item.ztcgqWxzs == null ? 'color:lime' : 'color:#ff6464'">正常</p>
          </div>
         <!-- <div>
            <p class="titnames1" v-if="item.fangxunYj!=null" :style="item.fangxunYj > 30 ? 'color:#ff6464' : 'color:lime'">{{item.fangxunYj}}%</p>
            <p class="titnames1" v-if="item.fangxunYj==null" :style="item.fangxunYj > 30 ? 'color:#ff6464' : 'color:lime'">0</p>
          </div> -->
        </li>
      </ul>
    </div>
    <div class="zrrlist">
      <div class="tit">
        <p>视频监控</p>
      </div>
      <video class="videostyle" autoplay controls="controls" src="../../common/video/video.mp4"></video>
    </div>
    <dialogs v-if="dialogVisible==true" @cancel="Cancel"></dialogs>
  </div>
</template>

<script>
  import {
    yaList,
    yjqd
  } from "@/api/api.js";
  import dialogs from "./Dialog.vue";
  import Url from "@/common/js/Url.js";
  export default {
    props: ["gisclick"],
    data() {
      return {
        yjlist: [],
        warninglist: [],
        dialogVisible: false,
      };
    },
    components: {
      dialogs,
    },
    watch: {
      gisclick(a) {
        let _this = this;
        if (a.ydbCode) {
          let params = {
            ydbCode: a.ydbCode
          };
          yaList(params).then((res) => {
            // console.log(res.data)
            _this.yjlist = res.data
          });
          yjqd(params).then((res) => {
            _this.warninglist = res.data;
          });
        }
      },
    },
    methods: {
      dialog() {
        this.dialogVisible = true;
      },
      Cancel() {
        this.dialogVisible = false;
      },
    },
    mounted() {},
  };
</script>

<style scoped>
  .totalPie,
  .zrrlist {
    width: 100%;
    height: 300px;
    background: url(../../common/images/contentborder.png) no-repeat center;
    background-size: 100% 100%;
    margin-top: 15px;
  }

  .tit {
    padding-bottom: 10px;
    border-bottom: 1px solid #098dc7;
  }

  .tit p {
    margin-top: 15px;
    /* font-size: 14px; */
  }

  .yjlist {
    width: 90%;
    margin: 0 auto;
    /* margin-top: 10px; */
    height: calc(100% - 75px);
    height: -webkit-calc(100% - 75px);
    height: -moz-calc(100% - 75px);
    overflow: auto;
  }

  .yjlist li {
    width: 100%;
    height: 35px;
    border-top: 1px solid #098dc7;
    cursor: pointer;
  }

  .yjlist li div:nth-child(1) {
    width: 50%;
    float: left;
    height: 35px;
  }

  .yjlist li div:nth-child(2) {
    width: 50%;
    float: left;
  }

  .yjlist li:nth-child(even) {
    background: rgba(0, 179, 254, 0.1);
  }

  .ddd {
    border-bottom: 1px solid #098dc7;
  }

  .titnames {
    line-height: 35px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    border-right: 1px solid #098dc7;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .titnames1 {
    line-height: 35px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sta1 {
    height: 35px;
    overflow: hidden;
    border-radius: 12px;
    margin: 0 auto;
    text-align: center;
    line-height: 35px;
    color: #fff;
    font-size: 14px;
    padding-right: 15px;
    background-url: "";
  }

  .listb {
    border-bottom: none;
    height: 36px;
    margin-top: 10px;
  }

  .listb li {
    background: rgba(0, 179, 254, 0.5);
    height: 35px;
  }

  .listb li div p {
    line-height: 30px !important;
    margin-top: 0px;
  }

  .qdimg {
    width: 30px;
    height: 30px;
    margin-top: 2px;
    margin-left: 40%;
  }

  .videostyle {
    width: 90%;
    height: 230px;
    margin-left: 5%;
    margin-top: 10px;
  }

  .listwarning {
    width: 90%;
    margin: 0 auto;
    overflow: auto;
  }

  .listwarning li {
    width: 100%;
    height: 35px;
    border-top: 1px solid #098dc7;
    cursor: pointer;
  }

  .ddd {
    border-bottom: 1px solid #098dc7;
  }

  .listwarning li div:nth-child(1) {
    width: 35%;
    float: left;
    height: 35px;
  }

  .listwarning li div:nth-child(2) {
    width: 25%;
    float: left;
    height: 35px;
  }

  .listwarning li div:nth-child(3) {
    width: 40%;
    float: left;
    height: 35px;
  }

  .listwarning li div {
    width: 15%;
    float: left;
    height: 35px;
  }
</style>
